import React, { useState } from 'react';

export default function IvoriSiteHeader() {
  const [navOpen, setNavOpen] = useState(false);

  const closeNav = () => setNavOpen(false);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    closeNav();
    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <header className="ivori-landing-header">
      <div className="ivori-landing-header-inner">
        <a className="ivori-landing-logo" href="#top" onClick={(e) => handleNavClick(e, 'top')}>
          IVORI
        </a>
        <nav
          id="ivori-landing-site-nav"
          className={`ivori-landing-nav ${navOpen ? 'ivori-landing-open' : ''}`}
        >
          <a href="#top" className="ivori-landing-active" onClick={(e) => handleNavClick(e, 'top')}>
            Home
          </a>
          <a href="#try" onClick={(e) => handleNavClick(e, 'try')}>
            Try
          </a>
          <a href="#board" onClick={(e) => handleNavClick(e, 'board')}>
            Decisions
          </a>
          <a href="#research" onClick={(e) => handleNavClick(e, 'research')}>
            Research
          </a>
          <a href="#marketplace" onClick={(e) => handleNavClick(e, 'marketplace')}>
            Marketplace
          </a>
          <a href="https://ivorilab.com" target="_blank" rel="noopener noreferrer" onClick={closeNav}>
            Lab
          </a>
        </nav>
        <button
          type="button"
          className="ivori-landing-nav-toggle"
          aria-label="Toggle menu"
          aria-controls="ivori-landing-site-nav"
          aria-expanded={navOpen}
          onClick={() => setNavOpen((open) => !open)}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 6h18M3 12h18M3 18h18" />
          </svg>
        </button>
      </div>
    </header>
  );
}
